export const simpleCompare = <T>(first: T, second: T): boolean => JSON.stringify(first) === JSON.stringify(second);
